import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonElafron';
const args = {};

export class OligonElafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
